import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useForgotUsernameQuery = (onSuccess?: () => void) => {
  const { mutateAsync } = useMutation((email?: string) => api.post(API_URL.CONTACTS_USERNAMES_FORGOT, { email }), {
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  });

  return mutateAsync;
};

export default useForgotUsernameQuery;
